import React from 'react';

import FacebookPixel from '../../components/FacebookPixel';
import OutbrainPixel from '../../components/OutbrainPixel';
import TaboolaPixel from '../../components/TaboolaPixel';

export default function scriptComponentResolver(
  scriptName: string
): Exclude<React.ReactNode, undefined> {
  switch (scriptName) {
    case 'facebookPixelMarketing': {
      return <FacebookPixel key="facebookPixelMarketing" />;
    }
    case 'outbrianPixel': {
      return <OutbrainPixel key="outbrianPixel" />;
    }
    case 'taboolaPixel': {
      return <TaboolaPixel key="taboolaPixel" />;
    }
    default:
      return null;
  }
}
